module.exports = __webpack_public_path__ + "img/cognitive_img05.f3b2c739.png";